import { FOOTNOTE_IDS } from '@oneaudi/confi-shared-components';
import { FootnoteReferenceV2 } from '@oneaudi/feature-app-utils';
import { Footnote } from '@oneaudi/footnote-service/dist/cjs/types/footnotes-response.type';
import { useAtomValue } from 'jotai/index';
import { useAppServices } from '~/app/contexts/app-context';
import { useFootnotes } from '~/components/footnotes';
import { MONTHLY_RATE_DIALOG_REMARK } from '~/components/footnotes/constants';
import { state } from '~/storage';

export default function MonthlyRateFootnote({ text }: { text: unknown }) {
	const {
		featureServices: { footnoteService },
	} = useAppServices();

	if (text) {
		const footnoteKey = `price-${FOOTNOTE_IDS.financingCalculationDisclaimer}`;
		const footnote = [{ Key: footnoteKey, Text: text?.toString() ?? '' } as Footnote];
		const alreadyExistingFootnotes = footnoteService?.getData();

		const footnoteFound = alreadyExistingFootnotes?.find((d) => d.Key === footnoteKey);
		if (footnoteFound) {
			footnoteService?.replaceFootNotes(footnote);
		} else {
			footnoteService?.addFootNotes(footnote);
		}
	}

	return <FootnoteReferenceV2 footnoteId={`price-${FOOTNOTE_IDS.financingCalculationDisclaimer}`} />;
}

export function RegisterOrUpdateRateFootnoteForDialog(): string | null {
	const { registerFootnote, getReference, updateFootnote } = useFootnotes();
	const disclaimer = useAtomValue(state.financingDisclaimerText);
	const footnoteReference = disclaimer ? registerFootnote(MONTHLY_RATE_DIALOG_REMARK, disclaimer) : null;
	const existingFootnoteReference = getReference(MONTHLY_RATE_DIALOG_REMARK);

	if (existingFootnoteReference && existingFootnoteReference !== '') {
		updateFootnote(MONTHLY_RATE_DIALOG_REMARK, disclaimer);
	}
	return footnoteReference;
}
